import { Dispatch, SetStateAction, useState } from "react";
import {
  Button,
  FieldError,
  Form,
  Input,
  Label,
  TextField,
} from "@heroui/react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useHookFormMask } from "use-mask-input";

import { authClient } from "@/shared/auth";

interface IFormInput {
  phone: string;
}

type PhoneAuthCardProps = {
  setPhone: Dispatch<SetStateAction<string | undefined>>;
};

export const PhoneAuthCard = ({ setPhone }: PhoneAuthCardProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<IFormInput>();
  const registerWithMask = useHookFormMask(register);

  const onSubmit: SubmitHandler<IFormInput> = ({ phone }) => {
    const phoneNumber = `+7${phone}`;

    setIsLoading(true);
    authClient.phoneNumber
      .sendOtp({ phoneNumber })
      .then(() => setPhone(phoneNumber))
      .catch((err) => setError("phone", { type: "server", message: err }))
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="w-[386px] h-[400px] pr-6">
      <div className="flex flex-col gap-3 pt-8 pb-0">
        <h1 className="text-2xl font-semibold text-[#212121]">
          Номер телефона
        </h1>
        <p className="text-[#212121]">
          Поможет создавать и отслеживать вашизаказы
        </p>
      </div>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="gap-4 mt-11 w-full">
          <TextField isInvalid={!!errors.phone?.message}>
            <Label className="text-[#571B23]">Номер телефона</Label>
            <Input
              className="bg-white shadow-none"
              disabled={isLoading}
              type="tel"
              {...registerWithMask("phone", "+7 (999) 999 99 99", {
                required: "Укажите номер телефона",
                autoUnmask: true,
              })}
            />
            <FieldError>{errors.phone?.message}</FieldError>
          </TextField>

          <Button
            className="w-full font-medium h-12 bg-[#571B23] mt-12"
            variant="primary"
            isPending={isLoading}
            type="submit"
          >
            Отправить код
          </Button>
        </div>
      </Form>
    </div>
  );
};
